import { lazy } from 'react'
import i18n from 'common/i18n'
import { lazyRetry } from '../help/utils'

const InconsistenciesDashboard = lazy(() => lazyRetry(() => import('containers/Dashboards/InconsistenciesDashboard')))

const route = [
  {
    name: i18n.t('routes.inconsistenciesDashboard.index'),
    path: '/inconsistencies-dashboard',
    main: InconsistenciesDashboard,
    exact: true,
    permissions: ['ROLE_VISUALIZAR_DASHBOARD_INCONSISTENCIAS']
  }
]

export default route
